import * as React from "react";
import SidebarLayout from "../../components/layout/sidebar_layout";
import {useAuthManager} from "../../components/utils/auth";
import {Navigate} from "react-router-dom";
import {UserAuthItemTypeEnum} from "arteco-api-client-ts";

const NON_ADMIN_TYPES = new Set<string>([
    UserAuthItemTypeEnum.EMPLOYEE,
    UserAuthItemTypeEnum.PUBLIC,
]);

export const AdminLayout = () => {
    const authManager = useAuthManager();
    const selectedType = authManager.getSelectedAuthority()?.type?.toString();

    if (selectedType && NON_ADMIN_TYPES.has(selectedType)) {
        return <Navigate to="/app/employee" replace />;
    }

    return <SidebarLayout/>;
};
